module.exports = __webpack_public_path__ + "static/media/designing.ae0a1fa5.jpg";